import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "region-dashboards-representative-abroad-base-info__list" }
const _hoisted_2 = { class: "region-dashboards-representative-abroad-base-info__item-label" }
const _hoisted_3 = { class: "region-dashboards-representative-abroad-base-info__item-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.positionFull)
      ? (_openBlock(), _createElementBlock("li", {
          class: "region-dashboards-representative-abroad-base-info__item",
          key: _ctx.positionFull
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.positionFull), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactInfoItems, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "region-dashboards-representative-abroad-base-info__item",
        key: item
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item), 1)
      ]))
    }), 128))
  ]))
}